import tw, { styled } from 'twin.macro';

const Modal = styled.div<{ visible: boolean }>(({ visible }) => [
  `absolute inset-0 transition`,
  visible ? tw`visible` : tw`invisible opacity-0`,
]);

export default Modal;
